import { Component, Input, Output, OnInit, OnDestroy, EventEmitter } from '@angular/core';

import { Store } from '@src/store';
import { environmentsActions } from '@src/store/reducers/environmentsReducer';
import { userActions } from '@src/store/reducers/userReducer';

import * as _ from 'lodash';

@Component({
    selector: 'role',
    template: require('./role.component.html'),
    styles: [require('./role.component.scss')]
})
export class RoleComponent implements OnInit, OnDestroy {
    @Input() public set role(value) {
        this.selectAll = false;
        this._tempRole = this.deepCopy(value);
        this._role = value;
        this.setEnvTypesSelection();
        this.setPermissionsSelection();
    }

    public get role() {
        return this._role;
    }

    @Output() public onDuplicate = new EventEmitter();
    @Output() public onDelete = new EventEmitter();

    public selectAll: boolean;
    public permissionsCategories: any[];
    public environmentTypes: any[];

    private unSubscribers: any[];
    private unSubscribe: any;
    private _role: any;
    private _tempRole: any;

    constructor(private store: Store) {
    }

    public ngOnInit() {
        this.selectAll = false;
        this.unSubscribers = [
            this.store.subscribe(() => {
                const envTypesState = this.store.getState().environments.envTypes;
                if (envTypesState) {
                    this.environmentTypes = _.orderBy(envTypesState, ['order'], ['asc']);
                }
                const permissionsState = this.store.getState().user.permissions;
                if (permissionsState) {
                    this.permissionsCategories = permissionsState;
                }
            })
        ];
        this.store.dispatch({ type: environmentsActions.GET_ENV_TYPES });
        this.store.dispatch({ type: userActions.GET_PERMISSIONS });
    }

    public ngOnDestroy() {
        if (this.unSubscribers) {
            this.unSubscribers.forEach(x => x());
        }
    }

    public save() {
        if (this.role.isEditable === false) {
            return;
        }
        this._role.envTypesIds = _.map(_.filter(this.environmentTypes, { selected: true }), 'id');
        let selectedPermissionIds = [];
        if (this.permissionsCategories) {
            this.permissionsCategories.forEach((category: any) => {
                if (category && category.Value) {
                    category.Value.forEach((permission: any) => {
                        if (permission.selected) {
                            selectedPermissionIds = [...selectedPermissionIds, permission.id];
                        }
                    });
                }
            });
        }
        this._role.permissionIds = selectedPermissionIds;
        if (!this._role.description) {
            this._role.description = '';
        }
        if (this._role.isNew) {
            this._role.id = -1;
            this.unSubscribe = this.store.subscribe(() => {
                const roleState = this.store.getState().user.role;
                if (roleState && this._role.isNew) {
                    this._role.id = roleState.id;
                    delete this._role.isNew;
                    this.unSubscribe();
                }
            });
            this.store.dispatch({
                type: userActions.ADD_ROLE,
                payload: { roleId: this._role.id, roleData: this._role }
            });
        } else {
            this.store.dispatch({
                type: userActions.SAVE_ROLE,
                payload: { roleId: this._role.id, roleData: this._role }
            });
        }
        this._role.isEditable = true;
    }

    public cancel() {
        if (this.role.isEditable === false) {
            return;
        }
        this._role = this._tempRole;
        this._tempRole = this.deepCopy(this._role);
        this.setEnvTypesSelection();
        this.setPermissionsSelection();
    }

    public toggleAll() {
        if (this.role.isEditable === false) {
            return;
        }
        if (this.permissionsCategories) {
            this.permissionsCategories.forEach((category: any) => {
                category.indeterminate = false;
                category.selected = this.selectAll;
                if (category && category.Value) {
                    category.Value.forEach((permission: any) => {
                        permission.selected = this.selectAll;
                    });
                }
            });
        }
    }

    public toggleCategory(category: any) {
        if (this.role.isEditable === false) {
            return;
        }
        if (category.Value) {
            category.Value.forEach((x: any) => x.selected = category.selected);
            category.indeterminate = false;
        }
    }

    private setEnvTypesSelection() {
        if (this.environmentTypes) {
            this.environmentTypes.forEach(item => item.selected = false);
        }
        if (this._role) {
            if (this._role.envTypesIds) {
                this._role.envTypesIds.forEach((id: any) => {
                    const environmentType = this.environmentTypes.find(item => item.id === id);
                    if (environmentType) {
                        environmentType.selected = true;
                    }
                });
            }
        }
    }

    private setPermissionsSelection() {
        if (this.permissionsCategories) {
            this.permissionsCategories.forEach(category => category.selected = false);
        }
        if (this.permissionsCategories) {
            this.permissionsCategories.forEach((category: any) => {
                if (category && category.Value) {
                    category.Value.forEach((permission: any) => {
                        permission.selected = false;
                    });
                }
            });
        }
        if (this.permissionsCategories && this._role && this._role.permissionIds) {
            this.permissionsCategories.forEach((category: any) => {
                if (category.Value) {
                    category.Value.forEach((permission: any) => {
                        if (this._role.permissionIds.find((x: any) => x === permission.id)) {
                            permission.selected = true;
                        }
                    });
                    const selectedPermissions = category.Value.filter((x: any) => x.selected);
                    category.indeterminate = selectedPermissions.length === 0
                        ? false
                        : category.Value.length !== selectedPermissions.length;
                    if (selectedPermissions.length === 0) {
                        category.selected = false;
                    }
                    if (selectedPermissions.length === category.Value.length) {
                        category.selected = true;
                    }
                }
            });
        }
    }

    public onDeleteClick() {
        if (this._role.isEditable) {
            this.onDelete.emit();
        }
    }

    private deepCopy(obj: any) {
        if (!obj) {
            return obj;
        }

        return _.cloneDeep(obj);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/usersRolesManagement/roles-management/role/role.component.ts